import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {NzModalRef} from "ng-zorro-antd/modal";
import {TagService} from '../../../core/services/tag.service';
import {NzMessageService} from "ng-zorro-antd/message";

@Component({
  selector: 'app-add-edit-tags',
  templateUrl: './add-edit-tags.component.html',
  styleUrls: ['./add-edit-tags.component.scss']
})
export class AddEditTagsComponent implements OnInit {
  @Input() entryType?: string;
  @Input() tagId?: string;
  isButtonLoading = false;
  name = '';

  constructor(
    private modal: NzModalRef,
    private tagService: TagService,
    private nzMessageService: NzMessageService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
  }

  handleCancel(): void {
    this.modal.close({ message: 'error' });
  }

  async editTag(): Promise<void> {
    this.isButtonLoading = true;
    try {
      await this.tagService.updateTag({_id: this.tagId, name: this.name });
      this.nzMessageService.success(
        this.translocoService.translate('shared.tags.messages.updated')
      );
      this.isButtonLoading = false;
      this.modal.close({ message: "success" });
    } catch (error: any) {
      this.isButtonLoading = false;
      this.nzMessageService.error(error.message.message);
      this.modal.close({ message: "error" });
    }
  }

  async addNewTag(): Promise<void> {
    this.isButtonLoading = true;
    try {
      const newtag =  await this.tagService.createTag({ name: this.name });
      this.nzMessageService.success(
        this.translocoService.translate('shared.tags.messages.added')
      );
      this.isButtonLoading = false;
      this.modal.close({ message: "success", tag: {_id: newtag._id} });
    } catch (error: any) {
      this.isButtonLoading = false;
      this.nzMessageService.error(error.message.message);
      this.modal.close({ message: "error" });
    }
  }
}
